<template>
  <base-dialog
    :action="onAction"
    :action-name="'Add Bank Account'"
    :close="onClose"
    :title="'Add Bank Account'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-row>
        <v-col cols="12">
          <v-text-field
            outlined
            dense
            :disabled="true"
            v-model="model.country"
            label="Country"
          />

          <v-text-field
            outlined
            dense
            :disabled="true"
            v-model="model.currency"
            label="Currency"
          />

          <v-text-field
            outlined
            dense
            v-model="model.account_holder_name"
            label="Account Holder Name"
          />

          <v-text-field
            outlined
            dense
            v-model="model.routing_number"
            :placeholder="$t('bank_account.routing_number_placeholder')"
            :label="$t('bank_account.routing_number')"
          />

          <v-text-field
            outlined
            dense
            v-model="model.account_number"
            label="Account Number"
          />
        </v-col>
      </v-row>
    </template>
  </base-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"
import { getBankAccountToken } from "../../services/stripe.service"
import externalAccounts from "../../stores/modules/externalAccounts"
import { isErrorResponse } from "../../services/util.service"

export default {
  components: {
    BaseDialog,
  },

  data() {
    return {
      model: {
        country: 'CA', // hard coded until we expand
        currency: 'CAD', // hard coded until we expand
        account_holder_name: undefined,
        account_holder_type: 'company',
        routing_number: undefined,
        account_number: undefined
      },
    }
  },
  methods: {
    ...mapActions([ 'createExternalAccount' ]),
    onClose() {
      this.$emit('close')
    },
    onAction() {
      const doCreateBankAccount = result => {
        const { token, error } = result

        if (error) {
          this.$store.dispatch('snackError', error)

          return { status: 400 }
        } else {
          const tokenId = token.id
          const payload = { external_account: tokenId }
          return this.createExternalAccount(payload)
            .then(externalAccount => {
              if (!isErrorResponse(externalAccount)) {
                this.$emit('action', externalAccount)
              }

              return externalAccount
            })
        }
      }

      return getBankAccountToken(this.model)
        .then(doCreateBankAccount)
    }
  }
}
</script>
